import type { App } from '../../app.js';
import { h, button } from '../dom.js';
import { levelForXp, xpForLevel } from '../../persist.js';
import { dailySeed } from '@voidline/shared';

export function buildMenuScreen(app: App): HTMLElement {
  const level = app.playerLevel();
  const xpNow = app.progression.xp - xpForLevel(level);
  const xpNext = xpForLevel(level + 1) - xpForLevel(level);

  const item = (label: string, sub: string, fn: () => void, primary = false) =>
    h(
      'button',
      {
        class: `focusable menu-item${primary ? ' primary' : ''}`,
        style:
          'display:block; width: 380px; text-align:left; margin-bottom:12px; padding:14px 24px;',
        onclick: () => {
          app.audio.play('ui_confirm');
          fn();
        },
        onmouseenter: () => app.audio.play('ui_move'),
      },
      h('div', { text: label }),
      h('div', {
        class: 'subtle',
        text: sub,
        style: 'text-transform:none; letter-spacing:0.04em; font-weight:400; margin-top:3px;',
      })
    );

  const today = dailySeed();

  return h(
    'div',
    { class: 'screen', style: 'align-items:flex-start; justify-content:center; padding-left:8vw;' },
    h(
      'div',
      {},
      h('div', { class: 'title-xl', text: 'VOIDLINE', style: 'font-size:54px; margin-bottom:6px;' }),
      h('div', {
        class: 'subtle',
        style: 'margin-bottom:36px; letter-spacing:0.2em;',
        text: `${(app.settings.playerName || 'PILOT').toUpperCase()} · LEVEL ${level} · ${xpNow}/${xpNext} XP`,
      }),
      item('RACE', 'Solo grid — circuits, sprints, elimination', () => app.show('solo'), true),
      item('MULTIPLAYER', 'Quickplay, private rooms, room browser', () => app.show('multiplayer')),
      item('CHAMPIONSHIP', 'Five-series campaign across the league', () => app.show('championship')),
      item('TIME TRIAL', 'You, the clock, and your ghost', () =>
        app.show('solo')
      ),
      item('DAILY CHALLENGE', `Seeded circuit of the day — ${today.slice(-10)}`, () =>
        app.startSoloRace({
          trackId: `seed:${today}`,
          trackSeed: today,
          mode: 'timetrial',
          laps: 3,
          botCount: 0,
          botDifficulty: 'standard',
        })
      ),
      item('GARAGE', 'Eight craft, paint schemes, loadout', () => app.show('garage')),
      item('RECORDS', 'Stats, medals, personal bests', () => app.show('stats')),
      item('SETTINGS', 'Graphics, audio, controls, assists', () => app.show('settings')),
      item('FLIGHT SCHOOL', 'Re-run the tutorial', () =>
        app.startSoloRace({
          trackId: 'ionport',
          trackSeed: null,
          mode: 'timetrial',
          laps: 3,
          botCount: 0,
          botDifficulty: 'cruise',
          tutorial: true,
          useGhost: false,
        })
      )
    )
  );
}
